import { Eye,  XCircle, Send, Clock } from "lucide-react";
import { Card, CardContent } from "@/components/ui";

type titles = 'Active Chats' | 'Chats' | 'Failed' | 'Sent Today';

export const StatisticCard = ({ title, value }: { title: titles, value: number }) => {

  const iconMap = {
    'Active Chats': <Clock className="size-3 text-yellow-600" />,
    'Chats': <Eye className="size-3 text-purple-600" />,
    'Sent Today': <Send className="size-3 text-green-600" />,
    'Failed': <XCircle className="size-3 text-red-600" />,
  }

  const colorMap = {
    'Active Chats': 'yellow',
    'Chats': 'purple',
    'Sent Today': 'green',
    'Failed': 'red',
  }

  return (
    <Card>
      <CardContent className="p-4 py-2 flex items-center gap-2">
        <div className={`p-2 flex  items-center justify-center bg-${colorMap[title]}-100 rounded-full`}>{iconMap[title]}</div>
        <p className="text-sm font-medium text-muted-foreground">{title}</p>
        <p className="text-2xl font-bold ml-auto mr-4">{value}</p>
    </CardContent>
  </Card>
  )
}